var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg8 = function Svg8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "url(#paint0_linear_906_536214)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7742 21H7.59417C5.72945 20.85 2 19.38 2 14.7C2 11.55 5.0625 9.3 7.25 9.3C7.25 7.95 9 3 14.25 3C17.75 3 19.5 5.25 20.5302 6.6C21.4335 6.15 23.875 6.15 25.1875 6.6C26.5 7.05 30 9.3 30 13.8C30 18.3 26.0625 21 22.7742 21Z",
    fill: "url(#paint1_linear_906_536214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7764 23.1024C9.9708 23.1567 11.2057 26.4614 10.9168 27.5397C10.7751 28.0545 10.4123 28.4863 9.90772 28.7408C9.40309 28.9953 8.79759 29.0518 8.22345 28.8979C7.6493 28.7441 7.15317 28.3924 6.84339 27.9197C6.53361 27.447 6.43536 26.8917 6.5701 26.375C6.85901 25.2967 9.58189 23.0482 9.7764 23.1024Z",
    fill: "#42A0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7764 23.1024C16.9708 23.1567 18.2057 26.4614 17.9168 27.5397C17.7751 28.0545 17.4123 28.4863 16.9077 28.7408C16.4031 28.9953 15.7976 29.0518 15.2234 28.8979C14.6493 28.7441 14.1532 28.3924 13.8434 27.9197C13.5336 27.447 13.4354 26.8917 13.5701 26.375C13.859 25.2967 16.5819 23.0482 16.7764 23.1024Z",
    fill: "#42A0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7764 23.1024C23.9708 23.1567 25.2057 26.4614 24.9168 27.5397C24.7751 28.0545 24.4123 28.4863 23.9077 28.7408C23.4031 28.9953 22.7976 29.0518 22.2234 28.8979C21.6493 28.7441 21.1532 28.3924 20.8434 27.9197C20.5336 27.447 20.4354 26.8917 20.5701 26.375C20.859 25.2967 23.5819 23.0482 23.7764 23.1024Z",
    fill: "#42A0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_536214",
    x1: 3,
    y1: 2.5,
    x2: 15.375,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEB41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_906_536214",
    x1: 6.91448,
    y1: 4.5068,
    x2: 24.7045,
    y2: 21.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCFE1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8.b0653d1f.svg";
export { ForwardRef as ReactComponent };